module.exports = __webpack_public_path__ + "img/carrousel-pacs-5.5c882aa5.png";